import script from "./ReportHandler.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportHandler.vue?vue&type=script&setup=true&lang=ts"

import "./ReportHandler.vue?vue&type=style&index=0&id=328b2826&scoped=true&lang=scss"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-328b2826"]])

export default __exports__